import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { Product } from '~shared/models';
import { CarouselColor, COLOR_CLASSES } from '~app/modules/storyblok/constants';
import { Direction, DirectionType, NUMBER_6 } from '~shared/constants';
import { OnProductClickEvent, OnSwipeEvent, ProductSelection, StoryblokButton, StoryblokImage } from '../../../models';
import { PriceTypes } from '~shared/modules/price-type-toggler/price-type-toggler.module';

@Component({
  selector: 'app-advanced-banner-carousel',
  templateUrl: './banner-carousel.component.html',
  styleUrls: ['../advanced-carousel.component.scss', './banner-carousel.component.scss'],
})
export class BannerCarouselComponent implements OnChanges {
  @Input() title: string;
  @Input() isPromo: boolean;
  @Input() colorClass: string;
  @Input() trackingName: string;
  @Input() subHeading?: string;
  @Input() description?: string;
  @Input() button?: StoryblokButton[];
  @Input() color?: CarouselColor;
  @Input() products: Array<Product>;
  @Input() image?: StoryblokImage;
  @Input() pageType: string;
  @Input() productSelection?: ProductSelection[];
  @Input() isMobile?: boolean;
  @Input() isTablet?: boolean;
  @Input() isDesktop?: boolean;
  @Input() isLandScapeTablet?: boolean;
  @Output() onProductClick: EventEmitter<OnProductClickEvent> = new EventEmitter();
  @Output() onButtonClick: EventEmitter<void> = new EventEmitter();
  @Output() onNavigate: EventEmitter<OnSwipeEvent> = new EventEmitter();
  @Output() onSwipe: EventEmitter<OnSwipeEvent> = new EventEmitter();

  sbFormatParam = '/m/';
  DIRECTION = Direction;
  computedClasses: { [key: string]: boolean } = {};
  hasEndPadding: boolean = false;
  readonly NUMBER_6 = NUMBER_6;

  ngOnChanges(_changes: SimpleChanges) {
    const isColored: boolean =
      this.colorClass !== COLOR_CLASSES.white && this.colorClass !== COLOR_CLASSES.whiteWithPromo;
    this.computedClasses = {
      [this.colorClass]: !!this.colorClass,
      'advanced-carousel__banner-plus-carousel__colored': isColored,
    };

    this.hasEndPadding = isColored || (!isColored && (this.isMobile || this.isTablet || this.isLandScapeTablet));
  }

  onProductClickEvent(product: Product, priceType: PriceTypes, productIndex: number): void {
    this.onProductClick.emit({ product, priceType, productIndex });
  }

  onButtonClickAction(): void {
    this.onButtonClick.emit();
  }

  onProductCarouselNavigation(direction: DirectionType): void {
    this.onNavigate.emit({ direction });
  }

  onProductCarouselSwipe(direction: DirectionType): void {
    this.onSwipe.emit({ direction });
  }
}
